import { Box, IconButton, Typography } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useSelector } from 'react-redux';

import { FBoxContainer } from '../../../../base';
import { FORTA_BLUE } from '../../../../../utils/colors';
import PayorResponsibilityTable from './components/PayorResponsibilityTable';

import type { RootState } from '../../../../../store';

function PayorResponsibility() {
  const { current: claim } = useSelector((state: RootState) => state.claims);
  return claim ? (
    <FBoxContainer sx={{ my: 3, position: 'relative', borderRadius: '10px', boxShadow: 'none' }}>
      <Typography fontSize={21} color={FORTA_BLUE.primary} textAlign="left">
        Payor responsibility
      </Typography>
      {/* Note: Download invoice button will be enabled in the next release */}

      <IconButton
        sx={{
          position: 'absolute',
          borderRadius: '8px',
          right: 30,
          top: 10,
          color: FORTA_BLUE.primary,
          opacity: 0,
        }}
        disabled
        onClick={() => {}}
      >
        <FileDownloadOutlinedIcon sx={{ width: 21, height: 21, mt: 0.3, mr: 0.5 }} />
        <Typography>Invoice</Typography>
      </IconButton>
      <Box sx={{ overflowX: 'auto' }}>
        <PayorResponsibilityTable claim={claim} />
      </Box>
    </FBoxContainer>
  ) : null;
}

export default PayorResponsibility;
